import cloneDeep from 'lodash/cloneDeep'
import api from '@/api'
import c from '@/config'
import moment from 'moment'

const state = {
  // label
  drawType: 'positive_default',
  labelList: [],
  selectedLabel: null,
  frameRange: c.defaultFrameRange,
  labelComment: '',

  clothAssessment: {},

  selectedLabelerIdx: -1,
  labelers: [],

  reviewComment: '',
  bestLabeling: false,
}
const getters = {
  isFrameInRange(state, getters, rootState) {
    return (
      rootState.frameIdx >= state.frameRange[0] &&
      rootState.frameIdx <= state.frameRange[1]
    )
  },
  labelList(state, getters, rootState) {
    let labelList = state.labelList
    if (
      state.selectedLabel !== null &&
      state.selectedLabel >= 0 &&
      state.selectedLabel < labelList.length
    ) {
      labelList = cloneDeep(state.labelList)
      labelList[state.selectedLabel].active = true
    }
    return labelList.filter(
      label =>
        rootState.frameIdx >= label.frameRange[0] &&
        rootState.frameIdx <= label.frameRange[1],
    )
  },
  labelInfo(state) {
    if (state.selectedLabelerIdx < 0) return { clothAssessment: {} }
    return state.labelers[state.selectedLabelerIdx] || { clothAssessment: {} }
  },
  labelTable(state, getters) {
    const labelInfo = getters.labelInfo
    const reviewStatusMap = {
      Pending: '等待审核',
      Passed: '审核通过',
      Rejected: '审核驳回',
    }
    let reviewTime = ''
    let labelTime = ''
    if (labelInfo.reviewTimeInt64) {
      reviewTime = moment(labelInfo.reviewTimeInt64, 'YYYYMMDDHHmmss').format(
        'YYYY-MM-DD HH:mm:ss',
      )
    }
    if (labelInfo.labelTimeInt64) {
      labelTime = moment(labelInfo.labelTimeInt64, 'YYYYMMDDHHmmss').format(
        'YYYY-MM-DD HH:mm:ss',
      )
    }
    return [
      {
        bestLabeling: labelInfo.bestLabeling ? '是' : '否',
        detectionMachineId: labelInfo.detectionMachineId,
        factoryName: labelInfo.factoryName,
        labelComment: labelInfo.labelComment,
        labelTime,
        machineAlias: labelInfo.machineAlias,
        reviewComment: labelInfo.reviewComment,
        reviewStatus: reviewStatusMap[labelInfo.reviewStatus],
        reviewTime,
        reviewerName: labelInfo.reviewerName,
      },
    ]
  },
  labels(state, getters) {
    if (getters.labelInfo.labelData) {
      const labelData = JSON.parse(getters.labelInfo.labelData)
      const labelList = labelData.map(label => {
        return {
          type: `${label.type}_${label.typeDetail}`,
          frameRange: [label.startIndex, label.endIndex],
          area: label.position,
        }
      })
      let statusLabelList = labelList
      if (
        state.selectedLabel !== null &&
        state.selectedLabel >= 0 &&
        state.selectedLabel < labelList.length
      ) {
        statusLabelList = cloneDeep(labelList)
        statusLabelList[state.selectedLabel].active = true
      }
      return statusLabelList
    }
    return []
  },
  diffClothAssessment(state, getters, rootState) {
    const result = {}
    if (Object.keys(getters.labelInfo.clothAssessment).length === 0) return {}
    rootState.clothAssessmentConfig &&
      Object.keys(rootState.clothAssessmentConfig).forEach(clothKey => {
        state.labelers.forEach(labeler => {
          if (
            labeler.clothAssessment[clothKey] !==
            getters.labelInfo.clothAssessment[clothKey]
          ) {
            result[clothKey] = true
          }
        })
      })
    return result
  },
  curBaseLayer(state, getters, rootState) {
    const decodedVideo = rootState.decodedVideo
    if (decodedVideo.bufferArray.length > 0) {
      return {
        type: 'YUVBuffer',
        source: decodedVideo.bufferArray[rootState.frameIdx],
        width: decodedVideo.bufferWidth,
        height: decodedVideo.bufferHeight,
      }
    }
    return null
  },
  curLayerData(state, getters, rootState) {
    const result = []
    // 由于解码时会固定丢失前面几帧非关键帧，decodedVideo 和 detectInfo 数量不总是一致的，因此需要将detectInfo向右平移，对齐图像
    const alignment = rootState.detectInfo.length - rootState.frameCount
    const detectInfoData = rootState.detectInfo[rootState.frameIdx + alignment]
    if (detectInfoData) {
      result.push({ type: 'DETECT_RESULT', data: detectInfoData })
    }
    // shield area
    const lineShield = rootState.shieldInfo.line
    if (lineShield) {
      result.push({ type: 'SHIELD_LINE', data: lineShield })
    }

    // manually shield
    let manuallyShieldData = null
    const manuallyShield = rootState.shieldInfo.manually
    if (manuallyShield && !(manuallyShield instanceof Array)) {
      manuallyShieldData = manuallyShield
    }
    result.push({ type: 'SHIELD_MANUALLY', data: manuallyShieldData })

    // label
    result.push({ type: 'LABEL', data: getters.labelList })
    return result
  },
  tools(state, getters, rootState) {
    const result = []
    if (rootState.showMagnifier) {
      result.push({ name: 'TOOL_MAGNIFIER', diameter: rootState.diameter })
    }

    result.push({
      name: 'TOOL_INSPECT_LABEL',
      bias: 20,
      data: getters.labelList.map(label => {
        label.shape = c.labelTypes[label.type].shape
        return label
      }),
    })
    return result
  },
}
const mutations = {
  setLabelList(state, labelList) {
    state.labelList = labelList
  },
  setSelectedLabel(state, selectedLabel) {
    state.selectedLabel = selectedLabel
  },
  setLabelComment(state, labelComment) {
    state.labelComment = labelComment
  },
  setLabelers(state, labelers) {
    state.labelers = labelers
  },

  setClothAssessment(state, clothAssessment) {
    state.clothAssessment = clothAssessment
  },

  setSelectedLabelerIdx(state, selectedLabelerIdx) {
    state.selectedLabelerIdx = selectedLabelerIdx
  },
}
const actions = {
  fetchLabelers({ state, commit, getters, rootState, rootGetters }, options) {
    return new Promise((resolve, reject) => {
      api
        .getLabelers({ tarId: rootState.tarId, cameraId: rootGetters.cameraId })
        .then(({ data }) => {
          if (data.labelers) {
            const selectedLabelerIdx =
              (options && options.selectedLabelerIdx) || 0
            commit('setLabelers', data.labelers)
            commit('setSelectedLabelerIdx', selectedLabelerIdx)
          } else {
            commit('setLabelers', [])
            commit('setSelectedLabelerIdx', 0)
          }
          resolve()
        })
        .catch(reject)
    })
  },

  approveLabel({ state, commit, rootState, getters, rootGetters }) {
    return new Promise((resolve, reject) => {
      if (!getters.labelInfo.labelerName) {
        reject(new Error('labelerName 不能为空'))
        return
      }
      api
        .patchLabel({
          tarId: rootState.tarId,
          cameraId: rootGetters.cameraId,
          labelerName: getters.labelInfo.labelerName,
          data: {
            reviewStatus: 'Passed',
            reviewComment: state.reviewComment,
            bestLabeling: state.bestLabeling, // 是否为最佳标注
          },
        })
        .then(resolve)
        .catch(reject)
    })
  },
  rejectLabel({ state, commit, rootState, rootGetters, getters }) {
    return new Promise((resolve, reject) => {
      if (!getters.labelInfo.labelerName) {
        reject(new Error('labelerName 不能为空'))
        return
      }
      api
        .patchLabel({
          tarId: rootState.tarId,
          cameraId: rootGetters.cameraId,
          labelerName: getters.labelInfo.labelerName,
          data: {
            reviewStatus: 'Rejected',
            reviewComment: state.reviewComment,
            bestLabeling: false,
          },
        })
        .then(resolve)
        .catch(reject)
    })
  },
  handleToolEvent({ state, commit, rootState }, data) {
    switch (data.type) {
      case 'INSPECT_LABEL':
        state.selectedLabel = data.index
        break
      default:
        console.log(data)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
